
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { logout,mudarMensagens } from '../actions/AppActions';
import { connect } from 'react-redux';

import moment from 'moment-timezone';
import { decrypt, URL } from '../variables';
import { getLanguageTexts, getSelectedLanguage } from '../language';
import { CandidateValidationNotice } from './CandidateUi';

class Chat extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            redirect: false,
            path: '/',
            texto:'',
            chat_open:false,
            first:true,
            loading_chat:true,
            selectedLanguage: getSelectedLanguage()
        };
        this.messages_view=React.createRef();
    }

    handleLanguageChange = (event) => {
        this.setState({ selectedLanguage: event.detail || getSelectedLanguage() });
    }



    componentDidMount() {
        window.addEventListener('candidate_language_change', this.handleLanguageChange);
        if (this.messages_view.current) {
            this.messages_view.current.scrollTop = this.messages_view.current.scrollHeight;
        }

    }

    componentWillUnmount() {
        window.removeEventListener('candidate_language_change', this.handleLanguageChange);
        clearTimeout(this.logs_timeout);
        clearTimeout(this.timeout_get_messages);
    }

   
    componentDidUpdate(props,state){
        if(((this.state.chat_open==true && state.chat_open==false) || props.mensagens.length!=this.props.mensagens.length) && this.messages_view.current){
            this.messages_view.current.scrollTop = this.messages_view.current.scrollHeight;
        }
        
        if(this.state.first==true && (this.state.chat_open==true || this.props.show_call==true)){
            this.setState({first:false});
            this.get_messages();
        }

    }

    get_messages() {

        if (this.state.loading_chat == false) {
            this.setState({ loading_chat: true });
        }
        fetch(`${URL}api/get_messages/${this.props.processo.id}?v=a`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);

                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;

                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    // this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                    this.timeout_get_messages = setTimeout(() => {
                        this.get_messages();
                    }, 5000);
                }
                else {
                    this.props.mudarMensagens(resp.mensagens);
                    if (this.props.socket) {
                        this.props.socket.emit('msg_receive', {processo_id:this.props.processo.id, sala_id: this.props.sala.id, aluno_id: this.props.user.id, faculdade_id: this.props.faculdade.id });
                    }

                    this.setState({loading_chat:false},()=>{
                        if (this.messages_view.current) {
                            this.messages_view.current.scrollTop = this.messages_view.current.scrollHeight;
                        }

                    });

                }
            } catch (err) {
                // this.setState({ redirect: true });
                console.log(err);
                this.timeout_get_messages = setTimeout(() => {
                    this.get_messages();
                }, 5000);
            }

        })
            .catch((err) => {
                // this.setState({ redirect: true });

                console.log(err);
                this.timeout_get_messages = setTimeout(() => {
                    this.get_messages();
                }, 5000);
            });
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    sendMessage = () => {
        const message = this.state.texto.trim();
        if (message === '') return;

        if (this.props.send_message(message)) {
            this.setState({ texto: '' }, () => {
                if (this.messages_view.current) {
                    this.messages_view.current.scrollTop = this.messages_view.current.scrollHeight;
                }
            });
        }
    }

    



    render() {
        const t = getLanguageTexts(this.state.selectedLanguage);
        return (
            <div
                hidden={(this.props.show_call && (this.props.user.accessibility==false || this.props.user.type_supervisor=='none')) || (this.props.show_call && this.props.processo.is_interview==true)}
                id="chat_father"
                style={{padding:0}}
                className={`candidate-chat ${this.state.chat_open ? 'is-open' : 'is-collapsed'}`}>

                <button
                    id="close_chat"
                    type="button"
                    className="candidate-chat-header"
                    aria-expanded={this.state.chat_open}
                    onClick={() => this.setState({ chat_open: !this.state.chat_open })}>
                    <span className="candidate-chat-avatar" aria-hidden="true">
                        <i className="mdi mdi-account-tie"></i>
                    </span>
                    <span className="candidate-chat-heading">
                        <strong>{t.support_with_proctor}</strong>
                        <small><span className="candidate-chat-status-dot"></span> {t.support_channel}</small>
                    </span>
                    <i className={`mdi ${this.state.chat_open ? 'mdi-chevron-down' : 'mdi-chevron-up'} candidate-chat-toggle`} aria-hidden="true"></i>
                </button>

                {this.state.loading_chat==true && <div className="candidate-chat-loading">
                    <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="sr-only">{t.loading}</span>
                    </div>
                    <span>{t.loading_messages}</span>
                </div>}

                <div ref={this.messages_view} className="candidate-chat-messages" id="body_msg">
                    {this.props.mensagens.map((item, id) => {
                        if(item.type_message=='message'){
                            if (item.sender_id == this.props.user.id) {
                                return (
                                    <div key={id} className="candidate-chat-row is-own">
                                        <div className="candidate-chat-bubble">
                                            <p>{item.message}</p>
                                            <div className="candidate-chat-meta">
                                                <span>{moment(item.created_at).tz("America/Sao_Paulo").format('DD/MM/YYYY HH:mm')}</span>
                                                {item.visto == undefined && <i className="fas fa-clock"></i>}
                                                {item.visto == false && <i className="fas fa-check"></i>}
                                                {item.visto == true && <i className="fas fa-check-double"></i>}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            else if (item.receive_id == this.props.user.id) {
                                return (
                                    <div key={id} className="candidate-chat-row is-other">
                                        <div className="candidate-chat-bubble">
                                            <strong className="candidate-chat-sender">{item.sender_name}</strong>
                                            <p>{item.message}</p>
                                            <div className="candidate-chat-meta">
                                                <span>{moment(item.created_at).tz("America/Sao_Paulo").format('DD/MM/YYYY HH:mm')}</span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        }
                        else if(item.type_message=='comunicado'){
                            return (
                                <div key={id} className="candidate-chat-row is-announcement">
                                    <div className="candidate-chat-bubble">
                                        <strong className="candidate-chat-sender"><i className="mdi mdi-bullhorn-outline"></i> {item.name_comunicado}</strong>
                                        <p>{item.message}</p>
                                        <div className="candidate-chat-meta">
                                            <span>{moment(item.created_at).tz("America/Sao_Paulo").format('DD/MM/YYYY HH:mm')}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                        
                    })}
                </div>
                
                {this.props.processo.chat_type =='all' && <form className="candidate-chat-composer"
                style={this.props.connect == false && this.props.socket != null?{gridTemplateColumns:'none'}:{}}
                onSubmit={(event) => {
                    event.preventDefault();
                    this.sendMessage();
                }}>
                     {(this.props.connect == false && this.props.socket != null) ? 
                     <>
                     <CandidateValidationNotice tone="warning" title={t.unstable_connection}>{t.unstable_connection}</CandidateValidationNotice>
                     </>
                     :
                     <>
                    <label className="sr-only" htmlFor="candidate-chat-message">{t.type_message}</label>
                    <input
                        id="candidate-chat-message"
                        autoComplete="off"
                        onChange={(e) => this.setState({ texto: e.target.value })}
                        value={this.state.texto}
                        name="msg"
                        placeholder={t.type_message}
                        className="form-control msg_input" />
                    <button type="submit" className="candidate-chat-send" disabled={this.state.texto.trim() === ''} title={t.send_message}>
                        <i className="mdi mdi-send"></i>
                    </button>
                    </>}
                </form>}

                {this.props.processo.chat_type =='fiscal_to_student' && <div className="candidate-chat-readonly">
                    <i className="mdi mdi-lock-outline"></i>
                    <p>{t.readonly_proctor_channel}</p>
                </div>}

            </div>

        );
    }
}
const mapsStateToProps = (state) => (
    {
        tempo_atual: state.AppReducer.tempo_atual,
        processo: state.AppReducer.processo,
        sala: state.AppReducer.sala,
        token: state.AppReducer.token,
        user: state.AppReducer.user,
        mensagens: state.AppReducer.mensagens,
        socket: state.AppReducer.socket,
        connect: state.AppReducer.connect,
        faculdade:state.AppReducer.faculdade,
        show_call:state.AppReducer.show_call,
    }
);

export default withRouter(connect(mapsStateToProps, { logout,mudarMensagens })(Chat));
